<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<template>
  <v-breadcrumbs class="tw-breadcrumbs" :items="items">
    <template v-slot:item="props">
      <router-link
        :class="{
          'tw-breadcrumbs__link--disabled': props.item.disabled,
          'grey--text': props.item.disabled,
        }"
        :to="props.item.to"
        class="tw-breadcrumbs__link">
        {{ props.item.text }}
      </router-link>
    </template>
  </v-breadcrumbs>
</template>

<style lang="scss">

  .tw-breadcrumbs {
    padding-left: 0;

    &__link {
      text-decoration: none;

      &--disabled {
        cursor: default;
        pointer-events: none;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TwBreadcrumbs.vue